// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"93c796b7","348":"94d69c7a","571":"5680368a","924":"7ff0144b"}[chunkId] + ".chunk.js";
};